export default __webpack_public_path__ + "static/media/ic_add.57c7984c.svg";